import type { AdminClient, ApiResponse } from '../core/index.js'
import type { ConfigChange, ConfigChangeFilter, ConfigChangeSummary } from './types.js'

/** The audit module's admin calls: the root's configuration history. */
export interface AuditAdminApi {
  /** One page of changes, newest first (`GET /admin/config-changes`); `cursor` is the previous page's `nextCursor`. */
  listConfigChanges(filter: ConfigChangeFilter, cursor: string | null): Promise<{ items: ConfigChange[]; nextCursor: string | null }>
  /** The last `days` counted by area, person and day (`GET /admin/config-changes/summary`). */
  summarizeConfigChanges(days: number): Promise<ConfigChangeSummary>
}

export function createAuditAdminApi(client: AdminClient): AuditAdminApi {
  return {
    listConfigChanges: async (filter, cursor) => {
      const query = new URLSearchParams(Object.entries({ ...filter, ...(cursor ? { cursor } : {}) }).filter((entry): entry is [string, string] => typeof entry[1] === 'string' && entry[1] !== ''))
      const body = await client.call<ApiResponse<ConfigChange[]>>('GET', `/admin/config-changes${query.size > 0 ? `?${query}` : ''}`, undefined, true)
      return { items: body.data ?? [], nextCursor: body.meta?.nextCursor ?? null }
    },
    summarizeConfigChanges: (days) => client.call('GET', `/admin/config-changes/summary?days=${days}`),
  }
}
